export const BIRDVIEW_CARD_SKELETON_ROWS_COUNT = 3
